import DOMPurify from "dompurify";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FilePdf } from "@phosphor-icons/react";

export function generatePreviewHtml(report, sections) {
  if (!report) return "";
  const pc = report.brand_colors?.primary || "#FF4400";
  let html = `<div style="font-family:-apple-system,BlinkMacSystemFont,sans-serif;max-width:700px;margin:0 auto;color:#333">`;

  for (const sec of sections) {
    if (sec.section_type === "cover") {
      html += `<div style="background:${pc};padding:40px;text-align:center;border-radius:8px;margin-bottom:24px">
        <h1 style="color:white;font-size:28px;margin:0">${report.title || ""}</h1>
        <p style="color:rgba(255,255,255,0.8);margin:12px 0 0">${report.client_name || ""}</p>
        <p style="color:rgba(255,255,255,0.6);font-size:14px;margin:8px 0 0">${report.report_period?.start_date || ""} to ${report.report_period?.end_date || ""}</p>
      </div>`;
    } else if (sec.section_type === "strategy_note") {
      html += `<div style="border-left:3px solid ${pc};padding:16px 20px;margin:20px 0;background:#f9f9f9;border-radius:0 8px 8px 0">
        <h2 style="color:${pc};font-size:18px;margin:0 0 8px">${sec.title || "Strategic Rationale"}</h2>
        <p style="line-height:1.6;margin:0">${(sec.body || "").replace(/\n/g, "<br>")}</p>
      </div>`;
    } else if (sec.section_type === "content_item") {
      const snap = sec.content_snapshot || {};
      html += `<div style="border:1px solid #eee;border-radius:8px;margin:20px 0;overflow:hidden">
        <div style="background:#f5f5f5;padding:8px 16px;font-size:12px;color:#888">${snap.content_type || ""} | ${snap.platform || ""}</div>`;
      if (sec.editors_note) {
        html += `<div style="background:#fff7ed;padding:8px 16px;font-size:13px;color:#b45309;font-style:italic">Note: ${sec.editors_note}</div>`;
      }
      html += `<div style="padding:16px"><h3 style="color:${pc};margin:0 0 8px">${snap.topic || sec.title}</h3>
        <div style="white-space:pre-wrap;line-height:1.6;font-size:14px">${(snap.generated_draft || "").slice(0, 2000)}</div>
      </div></div>`;
    } else if (sec.section_type === "custom_text") {
      html += `<div style="margin:20px 0">
        ${sec.title ? `<h2 style="color:${pc};font-size:18px">${sec.title}</h2>` : ""}
        <p style="line-height:1.6;white-space:pre-wrap">${(sec.body || "").replace(/\n/g, "<br>")}</p>
      </div>`;
    } else if (sec.section_type === "divider") {
      html += `<hr style="border:none;border-top:1px solid #ddd;margin:24px 0">`;
    }
  }
  html += `</div>`;
  return html;
}

export function PreviewModal({ open, onOpenChange, report, sections, onExportPdf }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white text-gray-900 max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="preview-modal">
        <DialogHeader>
          <DialogTitle className="text-gray-900">Report Preview</DialogTitle>
        </DialogHeader>
        {/* HTML is self-generated by generatePreviewHtml (not user input) and sanitized via DOMPurify */}
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(generatePreviewHtml(report, sections), { ALLOWED_TAGS: ["div", "h1", "h2", "h3", "p", "hr", "br", "span"], ALLOWED_ATTR: ["style"] }) }} />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Close</Button>
          <Button onClick={() => { onOpenChange(false); onExportPdf(); }} className="bg-[#FF4400] hover:bg-[#FF6633] text-white">
            <FilePdf size={14} className="mr-1" /> Export PDF
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
